export default __webpack_public_path__ + "static/NNNittiGrotesk-Heading-7a0281c59856c3ede349e11189e258d7.eot";